/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useAuth } from "../../core/context/AuthContext";
import axios from "axios";
import { getImageUrl } from "../../utils/imageUrl";

const Header = () => {
  const route = all_routes;
  const { user, logout } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem("colorschema") === "dark_mode"
  );

  const toggleDarkMode = () => {
    const next = !isDarkMode;
    setIsDarkMode(next);
    localStorage.setItem("colorschema", next ? "dark_mode" : "light_mode");
  };

  useEffect(() => {
    const scheme = isDarkMode ? "dark_mode" : "light_mode";
    document.documentElement.setAttribute("data-layout-mode", scheme);
    // Also sync bits that some legacy parts of the theme might read
    document.documentElement.setAttribute("data-nav-color", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get("https://avastar-pos-backend.onrender.com/api/ingredients/low-stock");
        setNotifications(res.data);
      } catch (err) {
        console.error("Failed to fetch notifications");
      }
    };
    fetchNotifications();
    
    const fetchProducts = async () => {
      try {
        const res = await axios.get("https://avastar-pos-backend.onrender.com/api/products");
        setProducts(res.data);
      } catch (err) {
        console.error("Failed to fetch products for search");
      }
    };
    fetchProducts();

    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, []);

  const filteredProducts = searchQuery ? products.filter(p => p.name.toLowerCase().includes(searchQuery.toLowerCase())).slice(0, 5) : products.slice(0, 5);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const dismissNotification = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await axios.patch(`https://avastar-pos-backend.onrender.com/api/ingredients/${id}/dismiss-alert`);
      setNotifications(notifications.filter((noti) => noti._id !== id));
    } catch (err) {
      console.error("Failed to dismiss notification", err);
    }
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }




  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath src="assets/img/logo.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo logo-white">
            <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo-small">
            <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
          </Link>
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-searchinputs">
            <div className="top-nav-search">
              <Link to="#" className="responsive-search">
                <Search />
              </Link>
              <form action="#" className="dropdown">
                <div
                  className="searchinputs dropdown-toggle"
                  id="dropdownMenuClickable"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                >
                  <input 
                    type="text" 
                    placeholder="Search Products..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="search-addon" onClick={() => setSearchQuery("")}>
                    <span>
                      <XCircle className="feather-14" style={{cursor: 'pointer'}} />
                    </span>
                  </div>
                </div>
                <div
                  className="dropdown-menu search-dropdown"
                  aria-labelledby="dropdownMenuClickable"
                >
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="search" className="feather-16" />
                      </span>
                      {searchQuery ? "Search Results" : "Recent Products"}
                    </h6>
                    <ul className="search-tags">
                      {filteredProducts.map((p, idx) => (
                        <li key={p._id || idx}>
                          <Link to="/restaurant/menu-items">{p.name}</Link>
                        </li>
                      ))}
                      {filteredProducts.length === 0 && (
                        <li><span className="text-muted">No products found...</span></li>
                      )}
                    </ul>
                  </div>
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="help-circle" className="feather-16" />
                      </span>
                      Help
                    </h6>
                    <p>
                      How to Change Product Volume from 0 to 200 on Inventory
                      management
                    </p>
                    <p>Change Product Name</p>
                  </div>
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="user" className="feather-16" />
                      </span>
                      Customers
                    </h6>
                    <ul className="customers">
                      <li>
                        <Link to="#">
                          Aron Varu
                          <ImageWithBasePath
                            src="assets/img/profiles/avator1.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          Jonita
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          Aaron
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-10.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>
            </div>
          </li>
          {/* /Search */}

          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <FeatherIcon icon="maximize" />
            </Link>
          </li>
          {/* â”€â”€ Dark / Light mode toggle â”€â”€ */}
          <li className="nav-item nav-item-box" style={{ padding: '0 8px' }}>
            <button
              onClick={toggleDarkMode}
              className="btn d-flex align-items-center justify-content-center p-0"
              title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              style={{
                width: '38px',
                height: '38px',
                borderRadius: '50%',
                background: isDarkMode ? '#1e293b' : '#f8fafc',
                border: isDarkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                color: isDarkMode ? '#fbbf24' : '#64748b',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer'
              }}
            >
              <div style={{
                transition: 'transform 0.5s ease',
                transform: isDarkMode ? 'rotate(360deg)' : 'rotate(0deg)'
              }}>
                <FeatherIcon 
                  icon={isDarkMode ? "sun" : "moon"} 
                  style={{ width: '18px', height: '18px' }} 
                />
              </div>
            </button>
          </li>
          {/* Notifications */}
          <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              {/* <i data-feather="bell" /> */}
              <FeatherIcon icon="bell" />
              {notifications.length > 0 && <span className="badge rounded-pill">{notifications.length}</span>}
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  {notifications.length === 0 ? (
                    <li className="notification-message">
                      <div className="media d-flex justify-content-center pt-3 pb-3">
                        <span className="noti-details text-muted">No low stock notifications</span>
                      </div>
                    </li>
                  ) : (
                    notifications.map((noti, idx) => (
                      <li className="notification-message active" key={idx} style={{ position: "relative" }}>
                        <Link to="/inventory/ingredients">
                          <div className="media d-flex">
                            <span className="avatar flex-shrink-0 bg-danger-light text-danger rounded-circle justify-content-center align-items-center d-flex fw-bold" style={{width: "40px", height: "40px"}}>
                              <FeatherIcon icon="alert-triangle" className="feather-16" />
                            </span>
                            <div className="media-body flex-grow-1 pe-4">
                              <p className="noti-details m-0">
                                <span className="noti-title text-danger">Low Stock:</span> <span className="fw-bold">{noti.name}</span> is running out{" "}
                                <span className="noti-title text-muted">
                                  ({noti.currentStock} {noti.unit} remaining)
                                </span>
                              </p>
                            </div>
                          </div>
                        </Link>
                        <button
                          className="btn btn-sm text-muted p-0 border-0"
                          style={{ position: "absolute", top: "50%", right: "15px", transform: "translateY(-50%)", zIndex: 10 }}
                          onClick={(e) => dismissNotification(e, noti._id)}
                          title="Mark as read"
                        >
                          <FeatherIcon icon="x" style={{ width: "16px", height: "16px" }} />
                        </button>
                      </li>
                    ))
                  )}
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/inventory/ingredients">View Inventory</Link>
              </div>
            </div>
          </li>
          {/* /Notifications */}

          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  {user?.profileImage ? (
                    <img src={getImageUrl(user.profileImage)} alt="profile" style={{ width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover' }} />
                  ) : (
                    <div className="avatar-letter bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{width: '38px', height: '38px'}}>
                      {user?.name?.charAt(0) || 'U'}
                    </div>
                  )}
                </span>
                <span className="user-detail">
                  <span className="user-name">{user?.name || ""}</span>
                  <span className="user-role">{user?.role || ""}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img d-flex border-0 align-items-center h-auto bg-transparent">
                    {user?.profileImage ? (
                      <img src={getImageUrl(user.profileImage)} alt="profile" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }} className="me-3" />
                    ) : (
                      <div className="avatar-letter bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold fs-4 me-3" style={{width: '60px', height: '60px'}}>
                        {user?.name?.charAt(0) || 'U'}
                      </div>
                    )}
                  </span>
                  <div className="profilesets">
                    <h6>{user?.name || ""}</h6>
                    <h5>{user?.role || ""}</h5>
                  </div>
                </div>
                <hr className="m-0" />
                <Link className="dropdown-item" to={user?.role === 'Admin' ? route.generalsettings : route.profile}>
                  <i className="me-2" data-feather="settings" />
                  Settings
                </Link>
                <hr className="m-0" />
                <Link className="dropdown-item logout pb-0 w-100 border-0 bg-transparent text-start" to="/signin" onClick={logout}>
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </Link>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={user?.role === 'Admin' ? "generalsettings" : "profile"}>
              Settings
            </Link>
            <Link className="dropdown-item" to="signin" onClick={logout}>
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
